import React from 'react';
import PropTypes from 'prop-types';
import NotificationModal from 'bento-ordering/base/components/NotificationModal';

const ModifierNotFoundNotification = ({ closeModal, message }) => (
  <NotificationModal
    title="Could not add to cart because modifier not found"
    body={message}
    onClose={closeModal}
  />
);

ModifierNotFoundNotification.propTypes = {
  closeModal: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired
};

export default ModifierNotFoundNotification;
